<template>
    <div class="d-block">
        <Card :bordered="false">
            <div class="d-flex justify-start">
                <div class="d-block">
                    <RadioGroup v-model="kinds" type="button" button-style="solid" @on-change="getReports(1)">
                        <Radio :label="1">今天</Radio>
                        <Radio :label="0">历史</Radio>
                    </RadioGroup>
                </div>
                <span class="d-flex-item"/>
                <div class="d-flex justify-start">
                    <div class="d-block mr-ns width-140">
                        <Input clearable v-model="search.name" placeholder="用户名"/>
                    </div>
                    <div class="d-block mr-ns width-140">
                        <Input clearable v-model="search.phone" placeholder="电话"/>
                    </div>
                    <button class="btn btn-icons btn-warning" @click="getReports(page)">
                        <img src="static/icon/search-white@16px.png"/>
                    </button>

                </div>
            </div>
        </Card>

        <br/>

        <Card :bordered="false">
            <p slot="title">报告列表</p>
            <Table :columns="tableColumns" :data="tableData">
                <template slot-scope="{row, index}" slot="address">
                    <span>{{ row.regionName.replace(/,/g, '') }}{{ row.address }}</span>
                </template>
                <template slot-scope="{row, index}" slot="reportTime">
                    <span>{{ $moment(row.reportTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
                <template slot-scope="{row, index}" slot="action">
                    <button title="下载：脑电文件" class="btn btn-sm btn-icons btn-primary" v-if="row.assessConfig && row.assessConfig.gatherEeg" @click="onReports(row, index, 1)">
                        <img src="static/icon/download-white@16px.png"/>
                    </button>
                    <button title="查看/打印：筛查报告" class="btn btn-sm btn-icons btn-warning" @click="onReports(row, index, 2)">
                        <img src="static/icon/print-white@16px.png"/>
                    </button>
                    <button :title="'查看：' + row.scaleName + '记录表'" class="btn btn-sm btn-icons btn-info" v-if="row.assessConfig && (row.assessConfig.gatherScale || row.assessConfig.gatherOtherScale !== '')" @click="initPrints(row, index, 1)">
                        <img src="static/icon/zhuanzhendan-white@16px.png"/>
                    </button>
                    <button :title="'填写：' + row.scaleName + '转诊单'" class="btn btn-sm btn-icons btn-info" v-if="row.scale < 3 && row.assessConfig && (row.assessConfig.gatherScale || row.assessConfig.gatherOtherScale !== '')" @click="initPrints(row, index, 2)">
                        <img src="static/icon/zhuanzhendan-white@16px.png"/>
                    </button>
                </template>
            </Table>
            <br/>
            <Page :total="total" :current="page" :page-size="count" @on-change="getReports"/>
        </Card>
    </div>
</template>

<script type="text/javascript">
    export default {
        components: {},
        data(){
            return {
                search: {},

                kinds: 1, // 类型：0历史 1今天

                tableColumns: [
                    {
                        title: '编号',
                        key: 'serialNumber',
                        sortable: true,
                    },
                    {
                        title: '姓名',
                        key: 'name',
                        sortable: true,
                    },
                    {
                        title: '电话',
                        key: 'phone',
                    },
                    {
                        title: '地址',
                        slot: 'address',
                    },
                    {
                        title: '任务名称',
                        key: 'taskName',
                    },
                    {
                        title: '报告时间',
                        slot: 'reportTime',
                        sortable: true,
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'left',
                        width: 176,
                    }
                ],
                tableData: [],

                total: 0,
                page: 1,
                count: 10,
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initPrintsSaveSuccess');
        },
        async created() {
            await this.getReports(this.page);
        },
        async mounted() {
            await this.$bus.on('initPrintsSaveSuccess', async (data) => {
                console.log('this.initPrintsSaveSuccess---------->', data);
                if (!data) return;
                await this.getReports(this.page);
            });
        },
        methods: {
            async getReports(page){
                this.$Spin.show();
                this.page = page;
                let query = '&dataType=' + (this.kinds === 1 ? 'today' : 'history') + '&name=' + (this.search.name || '') + '&phone=' + (this.search.phone || '');
                let res = await this.$api.getHttp('task/report/center' + '?page=' + this.page + '&pageSize=' + this.count + query);
                this.$Spin.hide();
                console.log('this.getReports---------->', res);
                if (res.data.code !== 0){
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.tableData = res.data.data.rows;
                for (let i = 0; i < this.tableData.length; i++) {
                    let it = this.tableData[i];
                    if (it.testResult && it.testResult !== 'None'){
                        it.testResult = JSON.parse(it.testResult);
                        it.generated = it.testResult.generated;
                    }
                    if (it.scale === 1){
                        it.scaleName = '初筛';
                    }
                    if (it.scale === 2){
                        it.scaleName = '复筛';
                    }
                    if (it.scale === 3){
                        it.scaleName = '诊断';
                    }
                    if (it.scale === 4){
                        it.scaleName = '复诊';
                    }
                }
                this.total = res.data.data.total;
            },

            async onReports(data, index, kind){
                debugger
                console.log('this.onReports---------->', data, index, kind);
                if (kind === 1){
                    if (!data.brainFilePath || data.brainFilePath === ''){
                        return await this.$common.alertModel('error', '无可下载的原始脑电');
                    }
                    return await this.$common.download(data, 'brainFilePath');
                }
                if (kind === 2){
                    if (!data.generated || data.generated === ''){
                        return await this.$common.alertModel('error', '无可下载的筛查报告');
                    }
                    return window.open(this.$api.resHttp().download + data.reportPath, '_blank');
                }
            },

            async initPrints(data, index, type){
                console.log('this.initPrints---------->', data, index, type);
                if (data.testResult === 'None'){
                    return await this.$common.alertModel('error', '无测评结果数据');
                }
                let param = JSON.parse(JSON.stringify(data.testResult));
                if (data.scale === 2 && (param.preliminaryScreeningResult.langSocials.length === 0 || param.preliminaryScreeningResult.warningSigns.length === 0)){
                    return await this.$common.alertModel('error', '测评结果数据不完整');
                }
                    param.testUserId = data.testUserId;
                    param.testRecordId = data.testRecordId;
                    param.taskName = data.taskName;
                    param.reportTime = data.reportTime;
                    param.saveTime = data.saveTime ? data.saveTime : new Date().getTime();
                return await this.$bus.emit('initPrints', true, param, type, data.scale);
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/pages/report/index.vue